import type { JSX, ReactNode } from "react";
import { NavLink, Outlet, useSearchParams } from "react-router";

export type AppLayoutProps = {
  children?: ReactNode;
  topRight?: ReactNode;
};

export function AppLayout(props: AppLayoutProps): JSX.Element {
  const [searchParams] = useSearchParams();

  const fullScreen = searchParams.has("fullscreen");

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {!fullScreen && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div style={{ padding: "var(--size-large)" }}>
            <h1>Heliopolis</h1>
            <ul>
              <li key="home">
                <NavLink to="/">Home</NavLink>
              </li>
              <li key="accounting">
                <NavLink to="/accounting">Accounting</NavLink>
              </li>
              <li key="meals">
                <NavLink to="/meals">Meals</NavLink>
              </li>
              <li key="tasks">
                <NavLink to="/tasks">Tasks</NavLink>
              </li>
            </ul>
          </div>
          {props.topRight && <div style={{ padding: "var(--size-large)" }}>{props.topRight}</div>}
        </div>
      )}
      <main style={{ padding: "var(--size-large)" }}>{props.children ?? <Outlet />}</main>
    </div>
  );
}
